/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'o2': {
    width: 16,
    height: 16,
    viewBox: '0 0 61.05 57.82',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M45.68 26.57c0 16-8.75 26.1-22.59 26.1S.5 42.59.5 26.57 9.28.5 23.09.5s22.59 10.12 22.59 26.07zM47 45.61c0-3.41 2.76-5.95 6.43-5.95C57 39.65 59.7 42 59.7 45c0 2.18-7.45 5.51-10.22 8.28-2.4 2.4-2.77 4-2.77 4v.05h13.84"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/o2.js